import $ from "jquery";
import './style.scss';
import Cookies from "js-cookie";

declare global {
    interface Window {
        dataLayer: any[];
    }
}

// START cookie policy
$(document).ready(function () {
    const loadGtm = function() {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        });
        let f = document.getElementsByTagName('script')[0]
        let j = document.createElement('script')
        j.async = true
        j.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-K9XQ2F9N'
        f?.parentNode?.insertBefore(j, f);
    }

    if (!Cookies.get('accepted_cookies')) {
        setTimeout(function () {
            $(".cookie-overlay").addClass("show");
        }, 500);

        $(".accept-cookies-button").on("click", function () {
            Cookies.set('accepted_cookies', 'yes', { expires: 730 });
            loadGtm()
            $(".cookie-overlay").removeClass("show");
        });

        $(".close-cookies-button").on("click", function () {
            $(".cookie-overlay").removeClass("show");
            setTimeout(function () {
                $('.cookie-overlay').remove();
            }, 500);
        });
    } else {
        loadGtm()
    }
});
// END cookie policy

// START hide current language button
$(document).ready(function () {
    const currentLanguage = window.location.pathname.split('/')[1]
    const $languageSwitcherWidget = $('.elementor-widget-wpml-language-switcher')
    const $footerLanguageSwitcher = $('.wpml-ls-statics-footer')
    const $languagesInFooter = $footerLanguageSwitcher.find('.wpml-ls-item')

    if ($languagesInFooter.length < 2) {
        $footerLanguageSwitcher.addClass('d-none')
    } else {
        const $currentLanguageButton = $(`.wpml-ls-item-${currentLanguage}`)
        if ($currentLanguageButton) {
            $currentLanguageButton.addClass('d-none')

            if ($('.elementor-widget-wpml-language-switcher ul li').length === 1) {
                $languageSwitcherWidget.addClass('d-none')
                $footerLanguageSwitcher.addClass('d-none')
            }
        }
    }
})
// END hide current language button

// START fix checkout tabindex
$(document).ready(function () {
    const $billingFormRows = $('.woocommerce-billing-fields__field-wrapper').find('.form-row')
    const billingFormRowsLength = $billingFormRows.length
    $billingFormRows.each(function (_, element) {
        const $element = $(element)
        const field = $element.find('input, .select2')[0]
        if (field) {
            const priority = $element.data('priority') ?? 0
            $(field).attr('tabindex', priority + 1)
        }
    })
    const $shippingFormRows = $('.woocommerce-shipping-fields__field-wrapper').find('.form-row')
    $shippingFormRows.each(function (_, element) {
        const $element = $(element)
        const field = $element.find('input, .select2')[0]
        if (field) {
            const priority = $element.data('priority') ?? 0
            $(field).attr('tabindex', priority + billingFormRowsLength)
        }
    })
})
// END fix checkout tabindex

// START checkout shipping method select
$(document).ready(function () {
    if (window.location.pathname.includes('checkout')) {
        const $shippingMethodRadios = $('input[type="radio"].shipping_method')
        const $pickupShippingMethod = $shippingMethodRadios.filter('[id*="local_pickup"]')

        // Show on page load
        if ($pickupShippingMethod?.[0]?.checked) {
            $('.pickup-alert').addClass('show')
        }

        // Show/hide on method select
        $(document.body).on('click', function (e) {
            const $pickupAlert = $('.pickup-alert')
            const $shippingMethodsUlInEvent = $('#shipping_method')
            const $shippingMethodRadiosInEvent = $('input[type="radio"].shipping_method')
            const $pickupShippingMethodInEvent = $shippingMethodRadiosInEvent.filter('[id*="local_pickup"]')
            const $target = $(e.target)
            const $pickupShippingMethodWrapper = $pickupShippingMethodInEvent.closest('li')

            if ($target === $pickupShippingMethodWrapper || $.contains($pickupShippingMethodWrapper[0], e.target)) {
                $pickupAlert.addClass('show')
            } else if ($target === $shippingMethodsUlInEvent || $.contains($shippingMethodsUlInEvent[0], e.target) ) {
                $pickupAlert.removeClass('show')
            }
        })

        // Hide on close button click
        $(document.body).on('click', function (e) {
            if (e.target.classList.contains('pickup-alert-close-button')) {
                $('.pickup-alert').removeClass('show')
            }
        })
    }
})
// END checkout shipping method select


// START Team store filter
$(document).ready(function () {
    const $teamStoreFilterInput = $('#form-field-team_store_finder')
    const $teamStores = $('.elementor-widget-wl-category-grid .wl-col-5')

    // Add placeholder images where necessary
    const placeholderImage = '/wp-content/uploads/woocommerce-placeholder-300x300.png'
    $teamStores.each(function (_, element) {
        const $categoryWrapper = $(element).find('.ht-category-wrap')
        const $currentCategoryImage = $categoryWrapper.find('.ht-category-image')
        if (!$currentCategoryImage.length) {
            const href = $categoryWrapper.find('a').attr('href')
            const categoryImageWrapper = document.createElement('div')
            categoryImageWrapper.classList.add('ht-category-image', 'ht-category-image-zoom')
            const categoryImageAnchor = document.createElement('a')
            categoryImageAnchor.classList.add('ht-category-border')
            categoryImageAnchor.href = href
            const categoryImage = document.createElement('img')
            categoryImage.classList.add('attachment-large', 'size-large')
            categoryImage.src = placeholderImage
            categoryImage.width = 300
            categoryImage.height = 300
            categoryImage.loading = 'lazy'
            categoryImage.decoding = 'async'

            categoryImageAnchor.prepend(categoryImage)
            categoryImageWrapper.prepend(categoryImageAnchor)
            $categoryWrapper.prepend(categoryImageWrapper)
        }
    })

    // Hide/show based on input
    $teamStoreFilterInput.on('keyup', function (e) {
        const $target = $(e.target)
        const value = $target.val()

        if (value === '') {
            $teamStores.removeClass('d-none')
        } else if (value.length > 2) {
            $teamStores.addClass('d-none')
            $teamStores.each(function (_, element) {
                const $element = $(element)
                const $elementTitle = $element.find('.ht-category-content h3 a')
                const $elementTitleText = $elementTitle.text()
                if ($elementTitleText.toLowerCase().includes(value.toLowerCase())) {
                    $element.removeClass('d-none')
                }
            })
        }
    })
})
// END Team store filter

// START Postal Code lookup
function debounce(func, timeout = 200){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }

$(document).ready(function () {
    const url = '/wp-json/powerhouse/postcode'
    const addressTypes = ['billing', 'shipping']
    addressTypes.forEach((addressType) => {

        if ($(`#${addressType}_postcode`) && $(`#${addressType}_address_2`)) {
                document.addEventListener('keyup', debounce(function (e) {
                    const $postCodeField = $(`#${addressType}_postcode`)
                    const $houseNumberField = $(`#${addressType}_address_2`)
                    const $houseNumberAdditionField = $(`#${addressType}_address_3`)
                    if (e.target === $postCodeField[0] || e.target === $houseNumberField[0] || e.target === $houseNumberAdditionField[0]) {
                        const postcode = $postCodeField.val().replace(/\s/g, '')
                        const houseNumber = $houseNumberField.val()
                        const houseNumberAddition = $houseNumberAdditionField.val()
                        const urlWithParams = `${url}?postcode=${postcode}&house_number=${houseNumber}&house_number_addition=${houseNumberAddition}`

                        if (postcode.length === 6 && houseNumber.length > 0) {
                            fetch(urlWithParams)
                                .then(response => response.json())
                                .then(data => {
                                    if (data.street) {
                                        $(`#${addressType}_address_1`).val(data.street)
                                        $(`#${addressType}_city`).val(data.city)
                                    }
                                })
                        }
                    }
                }))
        }
    })
})
// END Postal Code lookup